export default __webpack_public_path__ + "static/services-incident-response-parallax-db8e97adbdc3123c56522beefaa33c00.jpg";